//import usuarios from './usuarios/cuentas'
import usuarios from './Usuarios/cuentas'
import funciones from './funcion/funcion'

const cuentas = {
  usuarios: usuarios,
  funcion: funciones
}

export default cuentas



//////////////////
// WEBPACK FOOTER
// ./static/js/api/Cuentas/cuentasapi.js
// module id = null
// module chunks = 